module.exports = __webpack_public_path__ + "files/84daf741ed36b4f020e58651364f773b.png";